import request from "@/utils/wapRequest";

const urlHio = "https://wap-hio.vcallid.com";
const url = process.env.VUE_APP_BASE_LOGIN;

const GlobalAPI = {
  searchFacility(query) {
    return request({
      url: `${url}/services/search_courses_for_web`,
      method: "GET",
      params: query
    });
  },
  list_package(query) {
    return request({
      url: `${url}/services/list_package`,
      method: "GET",
      params: query
    });
  },
  facilityNearby(query) {
    return request({
      url: `${urlHio}/for_cms/nearby_for_insurance`,
      method: "GET",
      params: query
    });
  }
};
export { GlobalAPI as default };
